<script setup lang="ts">
import { ref, onMounted } from 'vue'
import profilService, { type Souscription } from '@/services/profilService'
import authService from '@/services/authService'
import { formatDateFrench } from '@/utils/formatters'

const souscription = ref<Souscription | null>(null)
const userPhone = ref('')

onMounted(async () => {
  const user = authService.getCurrentUser()
  if (user) {
    userPhone.value = user.telephone || ''
  }
  try {
    const res = await profilService.getSouscription()
    if (res.data) souscription.value = res.data
  } catch (e) {
    // silencieux - le widget ne s'affichera pas
  }
})
</script>

<template>
  <div class="sidebar-top px-3">
    <div class="widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6">
      <div class="flex align-items-center gap-4 mb-3">
        <img src="/public/icons/icon-souscription.svg" class="size-base icon-neutral" alt="" />
        <h4 class="secondary-font">Souscription</h4>
        <span v-if="souscription?.actif" class="tag-state success ml-4">Active</span>
        <span v-else class="tag-state ml-4">Inactive</span>
      </div>
      <h6 class="secondary-font text-primary-color mb-4">
        {{ souscription ? 'Valable jusqu\'au ' + formatDateFrench(souscription.date_fin) : '-' }}
      </h6>
      <h2 class="secondary-font">
        {{ userPhone || '-' }}
      </h2>
    </div>
  </div>
</template>
